import { useTheme } from '../../context/ThemeContext'; // Importar o hook do tema 

const SupportPanel = () => {
  const { isDarkMode } = useTheme();

  const openWhatsApp = () => {
    window.open('https://wa.me/5582996992182', '_blank');
  };

  const openEmail = () => {
    window.location.href = 'mailto:criaappoficial@gmail.com';
  };

  const openPhone = () => {
    window.location.href = 'tel:+5582996992182';
  };

  const contactItems = [
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
        </svg>
      ),
      title: "Email",
      value: "criaappoficial@gmail.com",
      action: openEmail,
      color: isDarkMode ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-700"
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
        </svg>
      ),
      title: "Telefone",
      value: "(82) 99699-2182",
      action: openPhone,
      color: isDarkMode ? "text-blue-400 hover:text-blue-300" : "text-blue-600 hover:text-blue-700"
    },
    {
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      ),
      title: "Horário de Atendimento",
      value: "Segunda a Sexta, 9h às 18h",
      color: isDarkMode ? "text-gray-400" : "text-gray-600"
    }
  ];

  return (
    <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} p-8 rounded-none shadow-lg border transition-all duration-300 hover:shadow-2xl ${isDarkMode ? 'hover:border-gray-600' : 'hover:border-blue-50'}`}>
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-none flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 4v-4m0-4h.01"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Suporte Premium</h3>
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} mt-1`}>Estamos aqui para ajudar</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="text-center">
        <div className={`mx-auto h-24 w-24 rounded-full flex items-center justify-center mb-6 shadow-inner ${isDarkMode ? 'bg-gradient-to-br from-blue-900/20 to-blue-800/20' : 'bg-gradient-to-br from-blue-50 to-blue-100'}`}>
          <svg className={`w-12 h-12 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
          </svg>
        </div>

        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} mb-8 max-w-md mx-auto text-lg leading-relaxed`}>
          Nossa equipe especializada está pronta para oferecer suporte personalizado e resolver suas dúvidas rapidamente.
        </p>

        {/* Contact Information */}
        <div className="space-y-5 text-left max-w-md mx-auto mb-8">
          {contactItems.map((item, index) => (
            <div
              key={index}
              className={`flex items-start p-4 rounded-none transition-colors duration-200 cursor-pointer ${item.action ? 'hover:shadow-md' : ''} ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-50 hover:bg-blue-50'}`}
              onClick={item.action}
            >
              <div className={`w-8 h-8 rounded-none flex items-center justify-center shadow-sm mr-4 flex-shrink-0 ${isDarkMode ? 'bg-gray-600' : 'bg-white'}`}>
                {item.icon}
              </div>
              <div className="flex-1">
                <p className={`text-sm font-semibold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} mb-1`}>{item.title}</p>
                <p className={`text-sm ${item.color} transition-colors duration-200`}>
                  {item.value}
                </p>
              </div>
              {item.action && (
                <svg className={`w-4 h-4 mt-1 flex-shrink-0 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                </svg>
              )}
            </div>
          ))}
        </div>

        {/* WhatsApp Button */}
        <button
          onClick={openWhatsApp}
          className="w-full max-w-md bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-4 px-6 rounded-none transition-all duration-300 transform hover:scale-105 hover:shadow-2xl flex items-center justify-center mx-auto group"
        >
          <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-white/30 transition-colors">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.864 3.488" />
            </svg>
          </div>
          <span className="text-lg">Conversar no WhatsApp</span>
          <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
          </svg>
        </button>

        {/* Footer Note */}
        <p className={`text-xs mt-6 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          Resposta garantida em até 15 minutos durante o horário comercial
        </p>
      </div>
    </div>
  );
};

export default SupportPanel;